<template>
  <div>
    <my-asidebar v-bind:active-tab="'coupon'"> </my-asidebar>

    <section class="dashboard-area">
      <top-bar></top-bar>
      <div class="dashboard-content-wrap">
        <div class="dashboard-bread dashboard--bread dashboard-bread-2">
          <div class="container-fluid">
            <div class="row align-items-center">
              <div class="col-lg-6">
                <div class="breadcrumb-content">
                  <div class="section-heading">
                    <h2 class="sec__title font-size-30 text-white">Ödemeler</h2>
                  </div>
                </div>
              </div>
              <div class="col-lg-6">
                <div class="breadcrumb-list text-right">
                  <ul class="list-items">
                    <li><a :href="basePath" class="text-white">Anasayfa</a></li>
                    <li>Ödemeler</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dashboard-main-content">
          <div class="container-fluid" >
            <coupon-list></coupon-list>
          </div>
        </div>
      </div>
      <use-coupon-popup></use-coupon-popup>
    </section>

  </div>
</template>

<script>
import PortList from "../component/port/PortList";
import PortDetail from "../component/port/PortDetail";
import TopBar from "../component/common/TopBar";
import MyAsidebar from "../component/common/MyAsidebar";
import PaymentList from "../component/payment/PaymentList";
import RefundList from "../component/payment/RefundList";
import CouponList from "../component/payment/CouponList";
import UseCouponPopup from "../component/common/UseCouponPopup";


export default {
  name: "CouponListPage",
  components: {
    UseCouponPopup,
    CouponList, RefundList, PaymentList, MyAsidebar,  PortDetail, PortList,  TopBar},
  computed:{
    basePath:{
      get(){
        return this.$store.getters.getBasePath
      }
    },
    paymentList:{
      get(){
        return this.$store.getters.getPaymentList
      }
    },
    refundList:{
      get(){
        return this.$store.getters.getRefundList
      }
    },
    couponList:{
      get(){
        return this.$store.getters.getCouponList
      }
    },
    panelRights:{
      get(){
        return this.$store.getters.getPanelRightsMap;
      }
    }
  },
  beforeCreate() {
    this.$store.dispatch("loadPaymentList");
    this.$store.dispatch("loadCouponList");
  },
  mounted() {
    if(!this.panelRights["PANEL_PAGE_COUPON_LIST"]) this.$router.push("/");

    this.$store.dispatch("loadPaymentList");
  }
}
</script>

<style scoped>

</style>